import {Service} from "@/services/Service";

export class EvidenciaService extends Service {
    constructor(axios) {
        super(axios, "");
    }

    registarEvidencia(datos) {
        this.onStart();
        return this.http.post(
                this.getUrl(['/registarEvidencia/']),
                datos,
                {
                    headers: {
                        'Content-Type': `multipart/form-data`,
                    },
                })
            .then(() => {})
            .catch(e =>this.onError(e))
            .finally(() => {
                this.onFinaly();
            })
    }

    obtenerRegistrosEvidencias(numeroEmpleado) {
        this.onStart();
        return this.http.get(this.getUrlQuery(['/obtenerRegistrosEvidencias/'], [numeroEmpleado]))
            .then((response) => JSON.parse(response.data))
            .catch(e =>this.onError(e))
            .finally(() => {
                this.onFinaly();
            })
    }

}